import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { GetOrganization200ServiceStatus } from "~/api/model";
import { useGetOrganization } from "~/api/organizations/organizations";
import { useGetCurrentUser } from "~/api/users/users";
import { useMedications } from "~/features/chat/hooks/useMedications";
import { getLoginUrl } from "~/helpers";
import { useProactiveTokenRefresh } from "~/hooks/useProactiveTokenRefresh";
import { AppHeader } from "../AppHeader";
import ErrorBoundaryWrapper from "../ErrorBoundaryWrapper";
import { PaymentFailedModal } from "../PaymentFailedModal";

export const AppLayout = () => {
  const location = useLocation();
  const { organizationId } = useParams<{ organizationId: string }>();
  const { data: userInfo, isLoading } = useGetCurrentUser();
  const { data: organizationInfo } = useGetOrganization(
    organizationId as string
  );

  useProactiveTokenRefresh();
  useMedications();

  const isChatPage = location.pathname.includes("/chat");

  const isPaymentFailed =
    organizationInfo?.serviceStatus ===
    GetOrganization200ServiceStatus.PAYMENT_FAILED;

  if (isLoading) {
    return null;
  }

  if (!userInfo) {
    return <Navigate to={getLoginUrl()} replace />;
  }

  return (
    <ErrorBoundaryWrapper>
      <div
        className={
          isChatPage ? "h-screen-safe overflow-hidden" : "min-h-screen-safe"
        }
      >
        {!isChatPage && <AppHeader />}
        <main className={isChatPage ? "h-full" : ""}>
          <Outlet />
        </main>

        {/* Modal for payment failed */}
        {isPaymentFailed && organizationId && (
          <PaymentFailedModal
            open={isPaymentFailed}
            organizationId={organizationId}
          />
        )}
      </div>
    </ErrorBoundaryWrapper>
  );
};
